import * as React from 'react';
import { useLocation } from 'wouter';
import { CmdLoader } from '@commander-services/gui-components';
import Config from '../../../config';
import ForgotPasswordLayout from './ForgotPasswordLayout';
import ForgotPasswordService from './ForgotPasswordService';
import { defaultLanguage } from '../LanguagesContext';

export default function ForgotPassword(): JSX.Element {
  const [form, isForm] = React.useState<any>(null);
  const [, navigate] = useLocation();

  React.useEffect(() => {
    const fetchData = async () => {
      const data = await ForgotPasswordService.getForm(defaultLanguage);
      if (data) {
        isForm(data.form);
      } else {
        navigate(Config.Login.homeUrl);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-login">
      {form && form.inputs && form.inputs.length > 0 ? (
        <ForgotPasswordLayout data={form.inputs} />
      ) : (
        <CmdLoader inContent={true} />
      )}
    </div>
  );
}
